import axios from "axios";
import { API_URL } from "../consts";

export const startTelegramLink = async () => {
  try {
    const response = await axios.post(`${API_URL}/telegram/link`);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      throw new Error("UNAUTHORIZED");
    }
    throw error;
  }
};

export const getTelegramLinkCode = async () => {
  try {
    const response = await axios.get(`${API_URL}/telegram/link/code`);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      throw new Error("UNAUTHORIZED");
    }
    throw error;
  }
};

export const getTelegramLinkStatus = async () => {
  try {
    const response = await axios.get(`${API_URL}/telegram/link/status`);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      throw new Error("UNAUTHORIZED");
    }
    throw error;
  }
};

export const unlinkTelegram = async () => {
  try {
    const response = await axios.delete(`${API_URL}/telegram/unlink`);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      throw new Error("UNAUTHORIZED");
    }
    throw error;
  }
};
